import type { ReactNode } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useIsFlagsOperator } from "../hooks/useIsFlagsOperator";

/**
 * Guardia de la app Feature Flags (#1212, épica #1219; copia idéntica en
 * CC-CONSOLE y WAYAK): la abre quien opera banderas — admin de plataforma,
 * owner o developer — con la MISMA regla que la API (`requireFlagsOperator`).
 * El admin de una empresa cliente no entra. No la gobierna la licencia ni el
 * rol del tenant: en CC-CONSOLE `/feature-flags` está fuera de las guardias
 * del catálogo (entitlementGates); en WAYAK la cubre además `app:feature-flags`.
 */
export default function FlagsOperatorRoute({
  redirectTo = "/apps",
  children,
}: {
  redirectTo?: string;
  /** Con `children`, protege ese elemento (p. ej. un layout); si no, el `<Outlet />`. */
  children?: ReactNode;
}) {
  const isOperator = useIsFlagsOperator();
  const location = useLocation();

  if (!isOperator) {
    return (
      <Navigate
        to={redirectTo}
        replace
        state={{ deniedPath: location.pathname, reason: "flags_operator_required" }}
      />
    );
  }

  return children ? <>{children}</> : <Outlet />;
}
